/**
 * <collapsible-content>
 *
 * Liten anpassad element-wrapper för "Visa mer / Visa mindre"-toggle.
 * Anledningen att det är ett custom element och inte en inline-script:
 * innerHTML-replace (t.ex. via tyg-switcher) re-executar inte <script>-taggar,
 * men custom element upgradas automatiskt när noden sätts in i DOM:en —
 * connectedCallback körs och eventlyssnaren binds om.
 *
 * Bevarat tillstånd: när användaren har expanderat ett kort och därefter byter
 * tyg, vill vi att den nya produkten också visas expanderad. Vi lagrar bara
 * "senaste valet" på window:en (per session, inte per produkt).
 */
class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.content = this.querySelector('[data-collapsible-content]');
    this.toggle = this.querySelector('[data-collapsible-toggle]');
    this.labelMore = this.querySelector('[data-collapsible-label-more]');
    this.labelLess = this.querySelector('[data-collapsible-label-less]');
    if (!this.content || !this.toggle) return;

    // Hämta senast valda state (session-globalt) och applicera direkt på den
    // nya instansen så användaren slipper "kollapseras tillbaka" efter swap.
    const expanded = window.__collapsibleContentExpanded === true;
    this.applyState(expanded);

    this.toggle.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    if (this.toggle) this.toggle.removeEventListener('click', this.onClick);
  }

  onClick() {
    const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
    this.applyState(!expanded);
    window.__collapsibleContentExpanded = !expanded;
  }

  applyState(expanded) {
    this.toggle.setAttribute('aria-expanded', String(expanded));
    this.content.classList.toggle('is-collapsed', !expanded);
    if (this.labelMore) this.labelMore.toggleAttribute('hidden', expanded);
    if (this.labelLess) this.labelLess.toggleAttribute('hidden', !expanded);
  }
}

if (!customElements.get('collapsible-content')) {
  customElements.define('collapsible-content', CollapsibleContent);
}
